<!--  -->
<template>
  <div>
    <!-- <div>
      <div class="serch_box">
        <el-input v-model="query.menuid" clearable style="width:200px;margin-right:10px" placeholder="请输入菜单id" />
        <el-button type="primary" style="margin:0px 10px" icon="el-icon-search" @click="searchclick">搜索</el-button>
        <el-button type="info" icon="el-icon-refresh-right" @click="rechargeclick">重置</el-button>
      </div>
    </div> -->
    <el-table
      ref="multipleTable"
      v-loading="loading"
      :data="tableData"
      :row-key="rowKey"
      border
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        type="selection"
        align="center"
        width="55"
        :reserve-selection="true"
        :selectable="selectable"
      />
      <el-table-column
        prop="account_name"
        label="公众号名称"
        width="150"
        align="center"
      />
      <el-table-column
        prop="appId"
        label="appId"
        width="180"
        align="center"
      />
      <el-table-column
        prop="status_text"
        label="绑定状态"
        width="150"
        align="center"
      />
      <el-table-column
        prop="remark"
        label="失败备注"
        width="180"
        align="center"
      >
        <template slot-scope="scope">
          <el-popover
            placement="top-start"
            title="失败备注"
            width="200"
            trigger="hover"
            :content="scope.row.remark"
          >
            <div slot="reference" class="titip">{{ scope.row.remark }}</div>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column
        prop="tag_group_id"
        label="标签组"
        align="center"
        width="300"
      >
        <template slot-scope="scope">
          <div v-if=" scope.row.normal_menu === false">
            {{ scope.row.tag_group_name }}( {{ scope.row.tag_group_id }})
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="creator"
        label="管理员"
        width="130"
        align="center"
      />
      <el-table-column
        prop="createdAt_text"
        label="创建时间"
        align="center"
        width="180"
      />
    </el-table>
    <pagination-right
      :current-page="query.page"
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
    <el-button type="primary" size="mini" @click="unbind">解绑</el-button>
  </div>
</template>

<script>
import PaginationRight from '@/components/PaginationRight/index.vue'
import { officialAccountMenuunbind } from '@/api/officialaccount.js'
import { officialaccountmenulist } from '@/api/sourceMaterial.js'
export default {
  components: { PaginationRight },
  data() {
    return {
      tableData: [],
      total: null,
      loading: false,
      query: {
        page: 1,
        pageSize: 10,
        templateId: null
      },
      selectlist: [],
      selectlistsend: []
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    rowKey(row) {
      return row.id
    },
    async list() {
      this.loading = true
      const data = await officialaccountmenulist(this.query)
      this.tableData = data.data.list
      this.total = data.data.total
      this.loading = false
      console.log('data', data)
    },
    // 分页
    fetchPageSize(e) {
      this.query.pageSize = e
      this.list()
    },
    fetchCurrentPage(e) {
      this.query.page = e
      this.list()
    },
    searchclick() {
      this.query.page = 1
      this.list()
    },
    rechargeclick() {
      this.query.page = 1
      this.query.menuid = null
      this.list()
    },
    send(val) {
      this.query.templateId = val
      this.list()
    },
    handleSelectionChange(rows) {
      this.selectlist = rows //
    },
    async unbind() {
      console.log(this.selectlist)
      if (this.selectlist.length === 0) {
        this.$message.error('请选择需要解绑的菜单')
        return
      }
      this.selectlistsend = []
      this.selectlistsend = this.selectlist.map((itemr, indexrs) => {
        // eslint-disable-next-line eqeqeq
        return itemr.id
      })
      const data = await officialAccountMenuunbind({
        ids: this.selectlistsend
      })
      this.$emit('updata')
      this.$message({
        message: '解绑成功',
        type: 'success'
      })
      console.log('data', data)
    },
    selectable(row, index) {
      // eslint-disable-next-line eqeqeq
      return row.normal_menu != true // 通过某个值来进行判断，规定那一行的选择框被禁用
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.serch_box{
  margin-bottom: 10px;
}
.sdwr{
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
}
.gecawe{
  display: inline-block;
  width: 100px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.defaultrse{
  color: #E6A23C;
}
.defaultr{
  color: #67C23A;
}
.stopew{
  color: red;
}
.fasrw{
  color: #409EFF;
}
.titip{
  width: 150px;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
  text-align: center;
}
</style>
